import React, { useMemo } from 'react';
import _ from 'underscore';
import { makeStyles, shorthands } from '@fluentui/react-components';
import { ToolbarContainer } from '@bingads-webui-campaign-react/toolbar-container';

const usePerfPageToolbarStyle = makeStyles({
  toolbarFilterContainer: {
    flexGrow: '1 !important',
    ...shorthands.padding('hidden'),

    '& .filter-list': {
      paddingTop: '10px',
      '& .asset-library-search': {
        display: 'inline-block',
        position: 'relative',
        top: '2px',
      },
    },

    '& .filter-list-editing': {
      '& .dropdown-filter-container': {
        display: 'inline-block',
        paddingTop: '12px',
      },

      '& .asset-library-search': {
        display: 'inline-block',
        paddingTop: '12px',
      },

      '& .top-rated-performance-filter': {
        alignSelf: 'center',
      },
    },
  },
});

export const useToolbarContainer = ({ isHideShowGraphButton }) => {
  const classes = usePerfPageToolbarStyle();

  const toolbarSelectedConfig = useMemo(() => new Map(), []);

  const renderToolbarContainer = ({
    i18n, filterBar, setDownloadShown, isChartShown, setChartShown, isEditingFilter,
  }) => {
    const toolbarUnselectedConfigList = [
      ['filter-bar', {
        id: 'filter-bar',
        type: 'custom',
        classes: classes.toolbarFilterContainer,
        content: filterBar,
      }],
      ['button-download', {
        type: 'nav-item',
        text: i18n.getString(_TL_('Download')),
        description: i18n.getString(_TL_('The download form is currently hidden. Select "Download" to display it')),
        id: 'button-download',
        iconLeftGlyphName: 'ba-Download',
        onClick: () => {
          setDownloadShown(true);
        },
        classes: 'button-download-form',
      }],
    ];

    const appName = new URLSearchParams(document.location.search).get('applicationName');
    if (appName !== 'BingAdsEditor') {
      toolbarUnselectedConfigList.push(['expand-table', { type: 'expand-table' }]);
    }

    if (!isHideShowGraphButton) {
      toolbarUnselectedConfigList.push(['button-chart-toggle', {
        type: 'nav-item',
        text: isChartShown ? i18n.getString(_TL_('Hide graph')) : i18n.getString(_TL_('Show graph')),
        description: isChartShown
          ? i18n.getString(_TL_('The performance graph is currently displayed. Select "Hide graph" to hide it.'))
          : i18n.getString(_TL_('The performance graph is currently hidden. Select "Show graph" to display it.')),
        id: 'button-chart-toggle',
        iconLeftGlyphName: isChartShown ? 'ba-Hide3' : 'ba-View',
        expanded: isChartShown,
        onClick: () => {
          setChartShown(!isChartShown);
        },
        classes: isChartShown ? 'button-hide-graph' : 'button-show-graph',
      }]);
    }

    const toolbarUnselectedConfig = new Map(toolbarUnselectedConfigList);

    const toolbarConfigInEditingFilterMode = new Map([
      ['filter-bar', {
        id: 'filter-bar',
        type: 'custom',
        classes: classes.toolbarFilterContainer,
        content: filterBar,
      }],
    ]);

    return (
      <ToolbarContainer
        i18n={i18n}
        forceHideToolbar={false}
        showToolbarSelected={false}
        showToolbarUnselected
        toolbarSelectedConfig={toolbarSelectedConfig}
        toolbarUnselectedConfig={isEditingFilter ? toolbarConfigInEditingFilterMode : toolbarUnselectedConfig}
        onClear={_.noop}
      />
    );
  };

  return { renderToolbarContainer };
};
